import {getCurrentLayout} from "../../appLayout";
import store from "../../../store";
import config from "../components/canvas/store/sqftConfig";
//import ManualCalculate from "../components/canvas/core/controls/manualCalculate";
import workspace from "../components/canvas/core/workspace";
import history from "../components/canvas/core/workspaceHistory";
import {
  enableSquareFootage,
  setSQFTViewMode,
  setSquareFootageGroup,
  updateSQFTCalculations
} from "../../../actions/sqftFunctions";
import {toggleSelectionFeatureInfo} from "../../../actions/actionFunctions";
import {manualCalculateImport} from "./sqftDataMapper";
import {getInitialManualCalcRows} from "../../../reducers/sqftManualCalculationReducer";
import {updateManualCalculateRows} from "../../../actions/sqftManualCalculationFunctions";
import {hashHistory} from "react-router";
import {
  getAvailableSteps, getCorrectedWizardGroupForFeature,
  navItemIsExcluded
} from "../../look/lookNavigation/lookMain/lookWizard/lookWizardFunctions";
import {getNextNotCheckedStep} from "../../qkbPages/materialsWizard/useChangeWizardStepRoute";
import {setMeasureUnit} from "./sqftConfigHelper";
import {CABINETS_TO_HANDLE, SQFT_VIEW_MODE} from "../constants";

export const getFeatureGroup = (mainNeeded = "center_island_countertop") => {
  const layout = getCurrentLayout();
  let featureGroup = layout.getSubPartFromQtCategories(mainNeeded);
  if (!featureGroup) {
    const foundGroup = layout.getFeatureGroupByPartId(mainNeeded);
    if (foundGroup) {
      featureGroup = {part: foundGroup}
    }
  }
  if (!featureGroup) {
    featureGroup = layout.parts["Countertop"] && layout.parts["Countertop"].countertop
      ? {part: layout.parts["Countertop"].countertop}
      : null;
  }

  return featureGroup
}

export const getHandleFeatureGroupFromShape = (shape) => {
  const layout = getCurrentLayout();
  const handlesPartId = CABINETS_TO_HANDLE[shape.partId];

  return layout.getFeatureGroupByPartId(handlesPartId);
}

export const getNavItems = (featureGroup, searchText = "", filters= {}, withPlaceholders = true,  withQuotingToolFeatures = false) => {
  let navItems = [];
  if (!featureGroup) {
    return navItems
  }
  let checkFeatureGroup = featureGroup.part ? featureGroup : {part: featureGroup}
  const state = store.getState();
  const {wizardIsActive} = state.wizardState;

  if (wizardIsActive) {
    navItems = getNavItemsFromTheWizard(checkFeatureGroup, searchText, filters);
  } else {
    const layout = getCurrentLayout();
    navItems = layout.designNavigationItems(checkFeatureGroup,
      filters,
      searchText,
      withPlaceholders,
      withQuotingToolFeatures,
      [],
      { firstFeature: null, firstConditions: null },
    )
  }

  return navItems;
}

export const onSQFTLoadPrepareData = () => {
  const layout = getCurrentLayout();
  const state = store.getState();
  const quotes = state.quotesState.quotes;
  const activeQuoteIndex = state.quotesState.activeQuoteIndex;
  const filterGroups = state.filterState.filterGroups;
  const fabricatorData = state.fabricatorState;

  //if (this.iframeElement && this.iframeElement.contentWindow) {
  const activeQuote = quotes[activeQuoteIndex];
  //const {intl, fabricatorData} = this.props;
  const measureUnit = fabricatorData.settings.measureUnit;
  const payload = {
    loadData: (activeQuote && activeQuote.sqFtCalcData) ? activeQuote.sqFtCalcData : null,
    measureUnit,
    fabricatorId: document.kvConfig.userId,
    fabricatorData,
    currentLayout: layout.getCurrentLayoutAbbreviation(),
    filterGroups: filterGroups,
    //language: intl.locale
  }
  // if (hardCodeIsLowes()) {
  //   let translates = {}
  //   Object.keys(intl.messages).forEach(messageKey => {
  //     if (messageKey.startsWith("transDoc.")) {
  //       if (!translates[intl.locale]) {
  //         translates[intl.locale] = {};
  //       }
  //       translates[intl.locale][messageKey] = intl.messages[messageKey]
  //     }
  //   })
  //   payload.translates = translates;
  // }
  console.log("sqft postMessage initial load data:", payload);

  return payload;
  //}
};

//todo is this all needed?
export const onSQFTLoadImport = (payload) => {
  let {fabricatorId, fabricatorData, currentLayout, measureUnit, loadData, filterGroups} = payload;
  config.fabricatorData = fabricatorData;
  window.fabricatorId = fabricatorId;
  window.currentLayout = currentLayout;
  config.filterGroups = filterGroups;
  //TranslatesProvider.replaceHtml(language, translates);
  // config.fabricatorData = fabricatorData; // set if needed

  //todo
  //toolbar.setFabricatorButtons(fabricatorData); // specific fabricator rules
  if (measureUnit) {
    [].slice.call(document.querySelectorAll(".settings-units [data-value]")).forEach(element => {
      (element.dataset.value === measureUnit)
        ? element.classList.add("active")
        : element.classList.remove("active")
    });
    setMeasureUnit(measureUnit);
    history.rememberConfig({measureUnit});
    //todo
    //ManualCalculate.onMeasureUnitChange();
  }
  if (loadData) {
    loadData = (typeof loadData === 'string') ? JSON.parse(loadData) : loadData;
    if (loadData.manualCalculate === true) {
      manualCalculateImport(loadData);
    } else {
      workspace.import(loadData);
    }
  } else if (!config.tutorialIsRunning) {
    workspace.import({}); // if new room is opened - clear the previous(but not the first time if tutorial is active)
    store.dispatch(updateManualCalculateRows(getInitialManualCalcRows()));
    //todo
    //ManualCalculate.import({})
  } else {
    store.dispatch(updateManualCalculateRows(getInitialManualCalcRows()));
  }
  const state = store.getState();
  const updateCalculations = state.sqftState.updateCalculations;
  store.dispatch(updateSQFTCalculations(updateCalculations + 1));
}

export const closeSQFTTool = (redirectToPage, shouldChangeWizardToNextStep, changeWizardStepRoute) => {
  const isSQFTinUrl = window.location.hash.includes("sqft");
  store.dispatch(setSQFTViewMode(SQFT_VIEW_MODE.twoDMode));

  if (isSQFTinUrl) {
    hashHistory.push(redirectToPage);
    if (shouldChangeWizardToNextStep) {
      changeWizardToNextStep(changeWizardStepRoute)
    }
  } else {
    store.dispatch(enableSquareFootage(false));
    store.dispatch(setSquareFootageGroup(null));
    if (shouldChangeWizardToNextStep) {
      changeWizardToNextStep(changeWizardStepRoute)
    }
  }
}

export const changeWizardToNextStep = (changeWizardStepRoute) => {
  const state = store.getState();
  const {wizardIsActive, wizardActiveItem} = state.wizardState;
  const {selectionFeatureInfo} = state.selectionState;
  if (wizardIsActive && wizardActiveItem) {
    if (selectionFeatureInfo) {
      store.dispatch(toggleSelectionFeatureInfo(null));
    }
    const realNextStep = getNextNotCheckedStep();
    changeWizardStepRoute(realNextStep);
  }
}

const getUpdatedNavItemWithWizardProps = (navItem, wizardGroup, newWizardStep) => {
  const newWizardGroup = getCorrectedWizardGroupForFeature(wizardGroup, navItem.part);
  return {
    ...navItem,
    newWizardGroupId: newWizardGroup.id, // this is saved in sqft data
    newWizardGroup, // this is passed to dropdown to select wizard values
    newWizardStep,
  }
}

export const getNavItemsFromTheWizard = (subPart, searchText = "", filters= {}, wizardGroupId = null, visualizerType = document.kvConfig.visualizerType, parentsList) => {

  let groupName = subPart.part.wasCreatedFromGroupName || subPart.part.dbName || subPart.part.partName; //assign same stems as for the parent featureGroup (for the slabs)
  const wizardSteps = getWizardGroupsFromTheWizard(groupName, wizardGroupId, false, parentsList);
  const layout = getCurrentLayout(visualizerType);
  const navItems = layout.designNavigationItems(subPart, filters, searchText, false, "all");

  // console.log("wizardSteps", wizardSteps);
  let allNavItems = [];
  if (wizardSteps.length) {
    if (wizardSteps.length === 1) {
      const navItemsFromWizardGroup = navItems.filter(navItem => !navItemIsExcluded(navItem, wizardSteps[0].stepGroups[0]))
      if (navItemsFromWizardGroup.length) {
        allNavItems = navItemsFromWizardGroup
        if (!wizardGroupId || wizardSteps[0].stepGroups[0]?.mergedGroups?.length > 1) {
          allNavItems = allNavItems.map(navItem => {
            return getUpdatedNavItemWithWizardProps(navItem, wizardSteps[0].stepGroups[0], wizardSteps[0].stepIndex)
          })
        }
      }
    } else {
      for (const wizardStep of wizardSteps) {
        const navItemsFromWizardGroup = navItems.filter(navItem => !navItemIsExcluded(navItem, wizardStep.stepGroups[0]));
        if (navItemsFromWizardGroup.length) {
          if (!allNavItems.length) {
            allNavItems = navItemsFromWizardGroup;
            if (!wizardGroupId || wizardStep.stepGroups[0]?.mergedGroups?.length > 1) {
              allNavItems = allNavItems.map(navItem => {
                return getUpdatedNavItemWithWizardProps(navItem, wizardStep.stepGroups[0], wizardStep.stepIndex)
              })
            }
          } else {
            navItemsFromWizardGroup.forEach(newNavItem => {
              if (!allNavItems.some(navItem => navItem.part.dbFeature.id === newNavItem.part.dbFeature.id)) {
                allNavItems.push(wizardGroupId
                  ? newNavItem
                  : getUpdatedNavItemWithWizardProps(newNavItem, wizardStep.stepGroups[0], wizardStep.stepIndex))
              }
            })
          }
        }
      }
    }
  }

  return allNavItems
}

/**
 * returns all wizardGroups with current groupName and wizard group id if provided
 * @param groupName {string}
 * @param wizardGroupId {string|number|null}
 * @param forFeature {featureInterface}
 * @param parentsList {object}
 * @returns {array}
 */
export const getWizardGroupsFromTheWizard = (groupName, wizardGroupId = null, forFeature = null, parentsList = null) => {
  const state = store.getState();
  const {wizardActiveItem, wizardSelectedValues} = state.wizardState;
  const {isRenuit} = state.fabricatorState;
  const wizardSteps = getAvailableSteps(wizardActiveItem, wizardSelectedValues, true);

  if (isRenuit && groupName === "Bottom Cabinet" && !wizardGroupId && parentsList && parentsList.top_cabinet
    && parentsList.top_cabinet.features && parentsList.top_cabinet.features[0]
    && parentsList.top_cabinet.features[0].feature && parentsList.bottom_cabinet && parentsList.bottom_cabinet.subPart
    && parentsList.bottom_cabinet.subPart.part) {
  // && wizardSelectedValues
  //   && Object.keys(wizardSelectedValues).some(key => {
  //     return wizardSelectedValues[key].wizardGroup && ((wizardSelectedValues[key].wizardGroup.id === 10)
  //       || (wizardSelectedValues[key].wizardGroup.id === 388))
  //   })
    const layout = getCurrentLayout();
    const sameBottomCabinetFeature = layout.getFeatureBySku(parentsList.top_cabinet.features[0].feature.dbFeature.sharedFeatureName, "bottom_cabinet", false, true);
    // console.log("sameBottomCabinetFeature", sameBottomCabinetFeature);
    if (sameBottomCabinetFeature) {
      const wizGroup = wizardActiveItem?.wizardGroups.find(wizGroup => {
        return wizGroup.groupName === "Bottom Cabinet" && wizGroup.featuresIncluded && wizGroup.featuresIncluded.length > 1
          && !navItemIsExcluded({part: sameBottomCabinetFeature}, wizGroup)
      });
      // console.log("wizGroup", wizGroup);
      if (wizGroup) {
        wizardSteps.push({
          stepGroups: [wizGroup],
          stepIndex: 6,
        });
      }
    }
  }

  return wizardSteps.filter((wizardStep) => {
    if (wizardStep.stepGroups.length !== 1 || (wizardStep.stepGroups[0].groupName !== groupName)) {
      return false
    }
    if (wizardGroupId && (wizardStep.stepGroups[0].id !== wizardGroupId)) {
      return false
    }
    if (forFeature) {
      return !navItemIsExcluded({part: forFeature}, wizardStep.stepGroups[0])
    }
    return true
  });
}

export const getUnderlaymentFeature = () => {
  const underlaymentFeatureGroup = getFeatureGroup('underlayment');
  const state = store.getState();
  const {wizardIsActive} = state.wizardState;
  let navItems;
  if (wizardIsActive) {
    navItems = getNavItemsFromTheWizard(underlaymentFeatureGroup, "", {});
  } else {
    const layout = getCurrentLayout();
    navItems = layout.designNavigationItems(underlaymentFeatureGroup,
      {},
      "",
      false,
      "all",
      [],
      { firstFeature: null, firstConditions: null },
    )
  }

  const underlaymentFeaureName = 'Xtone Underlayment';
  const underlaymentFeaure = navItems.find(navItem => navItem.part.getFeatureName() === underlaymentFeaureName);
  if (underlaymentFeaure) {
    return underlaymentFeaure
  }

  return navItems.length ? navItems[0] : null
}
